import React from 'react';
import { useTheme } from '../../hooks/useTheme';

interface LogoProps {
  /** Sizing/utility classes applied to the wordmark image (defaults to h-7 w-auto). */
  className?: string;
}

/**
 * METANOIA wordmark (the brand orb stands in for the "O"). Two assets so the
 * letters stay legible on either surface: the default light-gray wordmark for
 * the dark theme, and a black-text variant for the light theme. Size via the
 * `className` prop (height).
 */
export function Logo({ className = 'h-7 w-auto' }: LogoProps) {
  const theme = useTheme((s) => s.theme);
  const src = theme === 'light' ? '/metanoia-wordmark-light.png' : '/metanoia-wordmark.png';

  return (
    <img
      src={src}
      alt="METANOIA"
      className={`object-contain select-none ${className}`}
    />
  );
}
